import React from 'react';
import PageMeta from '../components/common/PageMeta';
import ComingSoonScreen from '../components/others/ComingSoonScreen';
import Layout from '../layout/Layout';
import Navbar from '../layout/Header/Navbar';
import FooterOne from '../layout/Footer/FooterOne';

const CommingSoon = () => {
  return (
    <Layout>
      <PageMeta title='Coming Soon- Software &amp; IT Solutions HTML Template' />
      <Navbar corporate/>
      <ComingSoonScreen />
    </Layout>
  );
};

export default CommingSoon;
